/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedCallDealerCta_user$ref: FragmentReference;
export type PdpSharedCallDealerCta_user = {|
  +profile: ?{|
    +email: ?string
  |},
  +authMetadata: ?{|
    +emailOnly: ?boolean
  |},
  +$refType: PdpSharedCallDealerCta_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedCallDealerCta_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "authMetadata",
      "storageKey": null,
      "args": null,
      "concreteType": "UserExistsMetadataType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "emailOnly",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4aa135194923a76a1ac478da4f9e1964';
module.exports = node;
